<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div id="header-container">
    <h3 id="header-text">Update Scenario Forecast</h3>
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            [disabled]="!workingScenario || !sourceScenarios ||  sourceScenarios?.length === 0 || startYear > endYear"
            (click)="updateScenario()">
      Update Scenario
    </button>
  </div>
</div>

<div class="d-flex flex-row ps-2 pe-2 gap-16">
  <div class="d-flex flex-column gap-8">
    <h3>Filter Working Scenario Records:</h3>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Region</mat-label>
      <mat-select
        [disabled]="regions?.length === 0"
        [(ngModel)]="selectedRegion"
        (selectionChange)="getFilters()">
        <mat-option *ngFor="let option of regions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Subregion</mat-label>
      <mat-select
        [disabled]="subregions.options.length === 0"
        [(ngModel)]="subregions.selectedOptions"
        (ngModelChange)="onFilterChange(SUBREGION)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of subregions.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Planning Market</mat-label>
      <mat-select
        [disabled]="planningMarkets.options.length === 0"
        [(ngModel)]="planningMarkets.selectedOptions"
        (ngModelChange)="onFilterChange(PLNGMKT)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of planningMarkets.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Market Division</mat-label>
      <mat-select
        [disabled]="marketDivisions.options.length === 0"
        [(ngModel)]="marketDivisions.selectedOptions"
        (ngModelChange)="onFilterChange(MKTDIV)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of marketDivisions.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Brandfam</mat-label>
      <mat-select
        [disabled]="brandfams.options.length === 0"
        [(ngModel)]="brandfams.selectedOptions"
        (ngModelChange)="onFilterChange(BRANDFAM)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of brandfams.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Body Style</mat-label>
      <mat-select
        [disabled]="bodyStyles.options.length === 0"
        [(ngModel)]="bodyStyles.selectedOptions"
        (ngModelChange)="onFilterChange(BODYSTYLE)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of bodyStyles.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Program Code</mat-label>
      <mat-select
        [disabled]="programCodes.options.length === 0"
        [(ngModel)]="programCodes.selectedOptions"
        (ngModelChange)="onFilterChange(PRGMCODE)">
        <mat-option [value]="['All']">All</mat-option>
        <mat-option *ngFor="let option of programCodes.options" [value]="[option]">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="d-flex gap-8 flex-row justify-content-center ">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-checkbox [(ngModel)]="updateComments"
                  [disabled]="workingScenario?.fcorg === GMTVP || selectedScenarioSource === ScenarioSelectionSource.TVP">
      Update Comments
    </mat-checkbox>
    <button mat-flat-button color="primary" (click)="getFilteredRecords()" [disabled]="startYear > endYear">
      Get Working Scenario Filtered Records
    </button>
    <button mat-flat-button color="primary"
            (click)="getMatchingRecordsMultipleScenarios()"
            [disabled]="!sourceScenarios || sourceScenarios?.length === 0 || startYear > endYear">
      Get Matching Records
    </button>
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <div class="w-100 content-height gap-8">
    <h3>Source Scenario:</h3>
    <div class="d-flex justify-content-center">
      <mat-button-toggle-group [(ngModel)]="selectedScenarioSource"
                               (ngModelChange)="onSourceChange()"
                               class="flex w-100 flex-grow-1"
                               [hideSingleSelectionIndicator]="true">
        <mat-button-toggle id="forecast-org-toggle" [value]="ScenarioSelectionSource.FCORG" class="d-flex flex-grow-1">
          By Forecast Org
        </mat-button-toggle>
        <mat-button-toggle id="global-scenario-toggle" [value]="ScenarioSelectionSource.GLOBAL"
                           class="d-flex flex-grow-1">
          By Global Scenario
        </mat-button-toggle>
        <mat-button-toggle id="tvp-toggle" [value]="ScenarioSelectionSource.TVP" class="d-flex flex-grow-1">
          By TVP Scenarios
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-vehicle-scenario-select
      titleText="Select Scenario"
      [validFcorgs]="validFcorgs"
      [isMultiSelect]="false"
      (confirmEvent)="onSelectEvent($event)"
      *ngIf="selectedScenarioSource ===ScenarioSelectionSource.FCORG "></app-vehicle-scenario-select>
    <app-global-scenario-select-component
      [user]="stateService.getUserGmid()"
      [memberScenarioType]="0"
      [filterNonGM]="true"
      (confirmEvent)="onGlobalScenarioSelect($event)"
      *ngIf="selectedScenarioSource ===ScenarioSelectionSource.GLOBAL "></app-global-scenario-select-component>
    <app-vehicle-scenario-select
      titleText="Select Scenario"
      [validFcorgs]="[GMTVP]"
      [isMultiSelect]="true"
      (confirmEvent)="onSelectEvent($event)"
      *ngIf="selectedScenarioSource ===ScenarioSelectionSource.TVP"></app-vehicle-scenario-select>
  </div>
</div>
